import * as THREE from "three";

/** A hollow square in the XY plane, with crisp corners and no filled center. */
export function squareFrameGeometry(inner: number, outer = 1): THREE.ShapeGeometry {
  const outline = new THREE.Shape([
    new THREE.Vector2(-outer, -outer), new THREE.Vector2(outer, -outer),
    new THREE.Vector2(outer, outer), new THREE.Vector2(-outer, outer),
  ]);
  outline.holes.push(new THREE.Path([
    new THREE.Vector2(-inner, -inner), new THREE.Vector2(-inner, inner),
    new THREE.Vector2(inner, inner), new THREE.Vector2(inner, -inner),
  ]));
  return new THREE.ShapeGeometry(outline, 1);
}
